import { LoginCard } from "@components/Cards";

import classes from "./Login.module.css";

export const Login = () => {
  return (
    <div className={classes.container}>
      <LoginCard />
    </div>
  );
};
